import React, { useState } from 'react'
import { getCurrency } from 'shared'
import { useFormContext } from 'react-hook-form'
import Warning from 'img/error-icons/red-error-exclamationmark.svg'
import './input.scss'

interface InputProps {
	label: string
	fieldName: string
	disabled?: boolean
	haveCurrency?: boolean
}
const FormInput = ({
	label,
	fieldName,
	disabled,
	haveCurrency,
}: InputProps) => {
	const {
		register,
		watch,
		formState: { errors },
	} = useFormContext()
	const fieldValue = watch(fieldName)
	const [isHover, setIsHover] = useState(false)

	return (
		<div className="input-container">
			<div className="form-field-header">
				<label htmlFor="input">{label}</label>
				{errors[fieldName] && (
					<div className="errorMsg">
						<div
							className={`errorText ${isHover ? 'visible' : ''}`}>
							{errors[fieldName]?.message}
						</div>
						<div
							onMouseEnter={() => setIsHover(true)}
							onMouseLeave={() => setIsHover(false)}>
							<img
								className="warningImg"
								src={Warning}
								alt="Invalid Value"
							/>
						</div>
					</div>
				)}
			</div>
			<input
				className="form-field"
				type="text"
				disabled={disabled}
				value={disabled ? 0 : fieldValue}
				{...register(fieldName)}
			/>
			{haveCurrency === true && (
				<div className="static-currency">{getCurrency()}</div>
			)}
		</div>
	)
}

export default FormInput
